import styled, { css } from 'styled-components';

const getSize = (props) => {
  if (props.large || props.size === 'large') {
    return '4.8rem';
  }

  if (props.xlarge || props.size === 'xlarge') {
    return '8rem';
  }

  if (
    props.size &&
    typeof props.size === 'string' &&
    props.size !== 'large' &&
    props.size !== 'xlarge'
  ) {
    return props.size;
  }

  return '3.2rem';
};

const FALLBACK_INITIALS = '1.2rem';
// 0.4 keeps the widest uppercase pair (MM, 1.75em in Roboto Bold)
// inside the border.
const INITIALS_TO_BOX_RATIO = 0.4;

// Emitted in the box's own unit: a px box under a rem font breaks the ratio
// whenever the browser's default font size is not 16px.
const getInitialsFontSize = (props) => {
  const match = String(getSize(props)).match(/^([\d.]+)(rem|px)?$/);
  if (!match) return FALLBACK_INITIALS;
  const font = parseFloat(match[1]) * INITIALS_TO_BOX_RATIO;
  return `${Math.round(font * 100) / 100}${match[2] || 'rem'}`;
};

const Img = styled.img`
  border-radius: 100%;
  overflow: hidden;
  height: ${(props) => getSize(props)};
  width: ${(props) => getSize(props)};
  max-width: 100%;
  flex-shrink: 0;

  ${({ showCursorPointer }) =>
    showCursorPointer &&
    css`
      cursor: pointer;
    `}

  ${({ isSquare }) =>
    isSquare &&
    css`
      border-radius: 0.4rem;
    `}
`;

const UnloadedImage = styled.div`
  font-size: ${(props) => getInitialsFontSize(props)};
  line-height: 1;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  border: 2px solid ${(props) => props.theme.config.colors.primary};
  background: ${(props) => props.theme.config.colors.light};
  border-radius: ${(props) =>
    props.borderRadius ? props.borderRadius : '50%'};
  font-weight: bold;
  text-transform: uppercase;
  color: ${(props) => props.theme.config.colors.secondary};
  user-select: none;
  height: ${(props) => getSize(props)};
  width: ${(props) => getSize(props)};

  ${({ showCursorPointer }) =>
    showCursorPointer &&
    css`
      cursor: pointer;
    `}
`;

export { Img, UnloadedImage, getInitialsFontSize };
